export default { 
  search:{ 
    placeholder: "Search", 
    enterButton: "Find" 
  }, 
  repository:{ 
    load_next_tooltip  : `{{present}} of {{count}} loaded`, 
    load_next: "More ...", 
  }, 
  adms:{ 
    repository_tooltip  : `Loaded {{count}} record. There are also {{length}} records available.`, 
    repository_load_next: "More ...", 
    distribution: { 
      title: "Distribution", 
      nolinks: "The catalog item is not distributed.", 
      nofiles: "There is no file to download for the content", 
      show: { 
        title: "Distribution details", 
        cancelText: "Cancel", 
        okText: "Ok", 
      }, 
      add: { 
        title: "Selecting a file to link", 
        cancelText: "Cancel", 
        okText: "Link", 
      }, 
      new: { 
        title: "New distribution", 
        cancelText: "Cancel", 
        okText: "Create", 
      }, 
      unlink:{ 
        title: 'Delete selected item', 
        okText: 'Yes',  
        cancelText: 'No', 
      }, 
      message: { 
        ok_link: "The file has been added.", 
        ok_unlink: "The entry has been deleted.", 
        e_detail: "An error occurred while retrieving more information and distributing a catalog item. {{detail}}", 
        e_search: "An error occurred while searching for files. {{detail}}", 
      }, 
    }, 
  }, 
  alphabet: { 
    letters: "ABCDEFGHIKLMNOPQRSTVXYZ", 
    loading: "Loading alphabet", 
  }, 
  editor:{ 
    theme: { 
      new : { 
        title: "New classifier", 
        cancelText: "Cancel", 
        okText: "Create" 
      }, 
      select : { 
        title: "Select classifier", 
        cancelText: "Cancel", 
        okText: "Link" 
      }, 
      message: { 
        ok_link: "The link has been created.", 
        ok_new: "The classifier has been added and linked to the catalog.", 
        e_new: "An error occurred while creating the classifier or establishing the link. {{detail}}", 
        e_unlink: "An error occurred while removing the link. {{detail}}", 
      } 
    }, 
    individual: { 
      new : { 
        title: "New item", 
        cancelText: "Cancel", 
        okText: "Create" 
      }, 
      select : { 
        title: "Select item", 
        cancelText: "Cancel", 
        okText: "Link" 
      }, 
      message: { 
        ok_link: "The link has been created.", 
        ok_new: "The item has been added and the link has been created.", 
        e_new: "An error occurred while creating the item or establishing the link. {{detail}}", 
        e_unlink: "An error occurred while removing the link. {{detail}}", 
      } 
    }, 
    literal: { 
      message: { 
        ok_save: "The data has been saved successfully.", 
      } 
    }, 
  }, 
  export: { 
    doc_book: "In Doc (book)", 
    doc_album: "In Doc (album)", 
    pdf_book: "In Pdf (book)", 
    pdf_album: "In Pdf (album)", 
  }, 
  skos: { 
    taxonomy_not_loaded: "The catalog taxonomy is not set or loaded!",
    conceptSmall: {
      details: "Details",
      deleteConcept: "Delete concept",
      unlinkFromScheme: "Remove from concept scheme",
      unlinkConcept: "Remove concept",
      replaceWithConcept: "Replace with concept",
      editConcept: "Edit concept"
    },
    deleteScheme: {
      title: "Delete concept scheme",
      cancel: "Cancel",
      close: "Close",
      delete: "Delete",
      loadingScheme: "Loading the concept scheme description…",
      loadingConcepts: "Loading the concept list…",
      deletingConcept: "Deleting concept {{current}} of {{total}}…",
      deletingScheme: "Deleting the concept scheme…",
      deleted: "The concept scheme and all its concepts were deleted.",
      irreversible: "Deletion is irreversible",
      warning: "Before deleting, consider exporting the concept scheme or asking an administrator to archive it. All concepts in the scheme will be deleted first, followed by the scheme itself.",
      deleteError: "Deletion error"
    },
    selectConcept: {
      loaderMissing: "No loader function was provided",
      loadConceptsError: "Failed to load the concept list",
      loadLabelsError: "Failed to load labels",
      searchPlaceholder: "Search by URI or label content",
      reload: "Reload",
      found: "Found: {{filtered}} of {{total}}",
      allConcepts: "All concepts",
      unlinkedConcepts: "Unlinked concepts",
      error: "Error",
      loadingUris: "Loading URIs...",
      loadingLabels: "Loading labels...",
      notFound: "No concepts found",
      select: "Select",
      noLabel: "No label",
      labelsNotFound: "No labels found",
      firstItemsShown: "The first {{count}} items are shown. Refine your search to narrow the list."
    },
    taxonomyValues: {
      deleteClassification: "Delete classification",
      editClassification: "Edit classification",
      schemeMissing: "The scheme for {{info}} is missing",
      deleteConfirmation: "Delete the selected classification?",
      yes: "Yes",
      no: "No",
      reloadToViewChanges: "Reload the page to view the changes."
    }
  }, 
  widgets: { 
    description_moreText: "Expand", 
    description_lessText: "Collapse", 
  }, 
  wiki: { 
    title: "Wiki page", 
    nolinks: "No related wiki pages", 
    select: { 
      title: "Selecting a wiki page", 
      cancelText: "Cancel", 
      okText: "Link", 
    }, 
    show: { 
      title: "Wiki article details", 
      cancelText: "Cancel", 
      okText: "Ok", 
    }, 
    new: { 
      title: "New article", 
      cancelText: "Cancel", 
      okText: "Create", 
    }, 
    unlink_dialog:{ 
      title: 'Delete selected item', 
      okText: 'Yes',  
      cancelText: 'No', 
    }, 
    message: { 
      ok_link: "The page has been added.", 
      ok_unlink: "The entry has been deleted.", 
      e_detail: "An error occurred while retrieving more information and distributing a catalog item. {{detail}}", 
      e_wiki: "An error occurred while retrieving additional information about the articles. {{detail}}", 
      e_search: "An error occurred while searching for pages. {{detail}}", 
      not_URL: "To fill in this field, specify a link to an HTML page in the Wiki article field.", 
    } 
  }, 
  settings:{ 
    settings_taxonomy: "Setting up classifiers", 
    taxonomy: "Classifiers", 
    settings_object: "Setting up object property directories", 
    object: "Directories", 
    catalog_public: "Public catalog", 
    catalog_signed: "Private catalog", 
    include_catalog: "Include in the catalog", 
    exclude_catalog: "Exclude from catalog" 
  }   
}
